import React from "react";
import { ProductDetailMedia } from "../../../../../../graphql/operations";
import useWindowSize from "../../../../../../utils/useWindowSize";
import {
  CloudinaryImage,
  CloudinaryTransformationParamKey,
  CloudinaryVideo,
} from "../../../../../Atoms/Cloudinary";
import styles from "../Story.module.css";

interface Props {
  media: ProductDetailMedia[];
}

const ChapterMedia: React.FC<Props> = ({ media }) => {
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
  const [isMouseOverVideo, setMouseOverVideo] = React.useState(false);

  const video = React.useMemo(
    () => media.find((m) => m.type.type === "video"),
    [media]
  );
  const image = React.useMemo(
    () => media.find((m) => m.type.type === "image"),
    [media]
  );
  const { width } = useWindowSize();

  if (image && image.mediaUrl) {
    return (
      <div className={styles.ChapterMediaImageContainer}>
        <CloudinaryImage
          transformations={["w_568", "h_320", "c_fill"]}
          src={image.mediaUrl}
        />
      </div>
    );
  }
  const shouldControlsShow = () => {
    if (isVideoPlaying && !isMouseOverVideo) {
      return false;
    }
    return true;
  };

  return (
    <div className={styles.VideoContainer} key={video.mediaUrl}>
      <CloudinaryVideo
        src={{
          url: video.mediaUrl,
        }}
        muted
        playsInline
        autoPlay
        onPlaying={() => setIsVideoPlaying(true)}
        onPause={() => setIsVideoPlaying(false)}
        onEnded={() => setIsVideoPlaying(false)}
        controls={shouldControlsShow()}
        onMouseOver={() => setMouseOverVideo(true)}
        onMouseLeave={() => setMouseOverVideo(false)}
        transformations={
          width <= 768
            ? ([
                `w_${Math.ceil(width / 2)}`,
              ] as CloudinaryTransformationParamKey[])
            : ["h_400"]
        }
      />
    </div>
  );
};

export default ChapterMedia;
